var React = require('react');

function IcoScreenOff (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.4258 47.9766C18.4258 41.2564 23.8736 35.8086 30.5938 35.8086H147.059C153.779 35.8086 159.227 41.2564 159.227 47.9766V127.938C159.227 134.658 153.779 140.105 147.059 140.105H30.5938C23.8736 140.105 18.4258 134.658 18.4258 127.938V47.9766ZM30.5938 46.2383C29.6337 46.2383 28.8555 47.0165 28.8555 47.9766V127.938C28.8555 128.898 29.6337 129.676 30.5938 129.676H147.059C148.019 129.676 148.797 128.898 148.797 127.938V47.9766C148.797 47.0165 148.019 46.2383 147.059 46.2383H30.5938Z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M67.0977 46.2383V129.676H56.668V46.2383H67.0977Z","fill":"currentColor","key":1})]);
}

IcoScreenOff.defaultProps = {"viewBox":"0 0 178 178"};

module.exports = IcoScreenOff;

IcoScreenOff.default = IcoScreenOff;
